import React from 'react';
import { FaPrint } from 'react-icons/fa'; // Importer les icônes nécessaires

// ButtonEdit avec une icône d'édition
const ButtonPrint = ({ onClick, className = '', hoverLabel = 'Imprimer'  }) => {
  return (
    <button
      onClick={onClick}
      aria-label={hoverLabel}
      title={hoverLabel} 
      className={`w-8 h-8 bg-green-500 text-white rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-green-700 flex items-center justify-center ${className}`}
    >
      <FaPrint className='text-[12px]'/>
    </button>
  );
};


export default ButtonPrint;
